import { render } from "./OpenCloseButton.vue?vue&type=template&id=664dee29"
import script from "./OpenCloseButton.vue?vue&type=script&lang=js"
export * from "./OpenCloseButton.vue?vue&type=script&lang=js"

import "./OpenCloseButton.vue?vue&type=style&index=0&id=664dee29&lang=css"

import exportComponent from "/builds/platform/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__